
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>学员中心</span><span>/</span><span>学员列表</span></div>
    <div class="disFlex between user-search">
      <div>
        <el-button type="primary" @click="toAdd()">添加学员</el-button>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.keyword" placeholder="请输入姓名/手机号查询" suffix-icon="el-icon-search"></el-input>
          </el-form-item>
         <!-- <el-form-item label="">
            <el-select v-model="formInline.state" placeholder="全部状态">
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div v-loading="loading">
      <div class="disFlex" style="flex-wrap:wrap;" v-if="tableData.rows.length>0">
        <div class="userInfoBlock" v-for="(item,k) in tableData.rows">
          <div class="disFlex between userevery-header">
            <div>
              <el-avatar size="medium" :src="getTxurl(item)"></el-avatar>
            </div>
            <div class="disFlex" style="align-items: center;height: 52px;cursor: pointer;">
              <div @click="toEdit(item.id)" v-if="item.roleCode!='COM_ADMIN_AQKT'"><img src="@/assets/images/icons/edit.png" />编辑</div>
              <div class="fenge"  v-if="item.roleCode!='COM_ADMIN_AQKT'">|</div>
              <div>
                <el-popover placement="right" trigger="hover">
                  <div>
                    <div class="czitem-list" @click="toDangan(item.id)">学习档案</div>
                    <div class="czitem-list" @click="showCard(item.id)">查看证件</div>
                    <div class="czitem-list" @click="delUser(item.id)"  v-if="item.roleCode!='COM_ADMIN_AQKT'">注销账号</div>
                  </div>
                  <span slot="reference"><img src="@/assets/images/icons/czuo.png" />操作</span>
                </el-popover>
              </div>
            </div>
          </div>
          <div class="">
            <div class="disFlex user-flex"><span class="likelabel">姓 名：</span><span class="likename"
                style="padding-right: 3px;">{{item.realName}}</span><img v-if="item.sex=='女'"
                src="@/assets/images/sexnv.png" /><img v-if="item.sex=='男'" src="@/assets/images/sexnan.png" /></div>
            <div class="disFlex user-flex"><span class="likelabel">部门：</span><span
                class="likename">{{item.orgName}}</span>
            </div>
            <div class="disFlex user-flex"><span class="likelabel">联系方式：</span><span
                class="likename">{{item.loginName}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>

    </div>
    <el-pagination :hide-on-single-page="true" style="margin-top: 10px;text-align: right;" background
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
      :page-sizes="[10, 20, 50, 100]" :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.total">
    </el-pagination>

    <el-dialog title="查看证件" :visible.sync="dialogCardVisible" :close-on-click-modal="true" :destroy-on-close="true" @close="creator=''">
      <CardList :creator="creator" v-if="creator"/>
    </el-dialog>
  </div>
</template>

<script>
  import CardList from '../common/CardList';
  export default {
    props: ['collapse', 'wjSrc','currentUser'],
    data() {
      return {
        formInline: {
          keyword: '',
          state: '',
          page: 1,
          rows: 10
        },
        tableData: {
          rows:[],
          total:0
        },
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        loading: true,
        dialogCardVisible:false,
        creator:''
      }
    },
    methods: {
      getUserList: function() {
        this.loading = true;
        this.$axios.get('/system/user_role/COM_USER_AQKT/list.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.tableData = data;
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/UserInfo');
      },
      toEdit: function(id) {
        this.$router.push('/Company/UserInfo?id=' + id);
      },
      // 跳转学员档案页面
      toDangan: function(id) {
        this.$router.push('/Company/ArchivesInfo?id=' + id);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else {
          return this.txnoUrl
        }
      },
      delUser: function(id) {
        var user={
          ids:id
        }
        this.$confirm('您确定要注销该账号吗?', '注销账号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/system/user_role/COM_USER_AQKT/del.htm?ids='+id, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            }
          }).then(res => {
            var data = res.data;
            if(data.stat=='1'){
              this.$message({
                type: 'success',
                message: '注销成功!'
              });
              this.getUserList()
            }
          })
        }).catch(() => {
        });
      },
      //
      showCard:function(id){
        this.creator=id;
        var $this=this;
        setTimeout(function(){
          $this.dialogCardVisible=true;
        },300)
      }
    },
    computed: {

    },
    created: function() {
      // this.getUserList();
      this.$set(this.formInline,'cid',this.currentUser.cid)
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList()
        },
        deep: true //true 深度监听
      }
    },
    components:{
      CardList
    }
  }
</script>

<style>
  .user-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .user-search .el-form-item {
    margin-bottom: 0;
  }

  .userInfoBlock {
    width: 256px;
    height: 168px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .userInfoBlock .userevery-header {
    height: 52px;
    opacity: 1;
    background: #e4f3fc;
    border-radius: 4px 4px 0px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    align-items: center;
    padding: 0 14px;
    color: #9a9a9a;
  }

  .fenge {
    padding: 0 19px;
  }

  .userInfoBlock .userevery-header img {
    padding-right: 6px;
  }

  .user-flex {
    margin-top: 10px;
    font-size: 14px;
    padding: 0 14px;
    align-items: center;
    line-height: 22px;
  }

  .likelabel {
    width: 90px;
    text-align: left;
  }

  .likename {
    color: rgba(0, 0, 0, 0.65);
  }

  .el-popover {
    padding: 0 !important;
    width: 110px !important;
    min-width: 110px !important;
  }

  .czitem-list {
    width: 110px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/UserList.vue